<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SlljUQ/tc-custom/9781449480288.jpg?1736959362938" alt="This image is the cover for the book Trouble with Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trouble with Women
      </h1>
      <p class="bookDescription body article font2">
        <p>Ever noticed that women don't feature much in history books, and wondered why? Then this is the book for you. In <i>The Trouble with Women</i>, feminist artist Jacky Fleming illustrates how the opinions of supposed male geniuses, such as Charles Darwin (who believed that women have smaller brains than men) and John Ruskin (who believed that women's main function was to praise men), have shaped the fate of women through history, confining them to a life of domesticity and very little else.<br/><br/> Get ready to laugh, wince, and rescue forgotten women from the "dustbin of history," while keeping a close eye out for tell-tale "genius hair."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacky Fleming
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eb080612